import useEditorTableColumns from './useEditorTableColumns'

export default useEditorTableColumns
